export default {"src":"/_next/static/media/hek.4db14bb3.svg","height":46,"width":140,"blurWidth":0,"blurHeight":0};